<div id="wil-search-v2" class="wil-content container-fullwidth">
    <div class="directory-heading container">
        <h1 class="text-center heading_title__1bzno">Directory</h1>
    </div>
    <div class="searchbox_module__3ZYKm">
        <div class="container">
            <form [formGroup]="listingSearchForm" (ngSubmit)="onSubmitListingForm()">
                <div class="searchbox_wrap__37JXq">
                    <div class="searchbox_searchInput__2p4ds">
                        <div class="field_module__1H6kT field_style5__3OR3T mb-0 js-field">
                            <div class="field_wrap__Gv92k wil-autocomplete-field-wrapper">
                                <div class="field_module__1H6kT field_style2__2Znhe active" posttype="listing">
                                    <div id="">
                                        <div role="combobox" aria-expanded="false" aria-haspopup="listbox"
                                            aria-owns="autosuggest-autosuggest__results" class="hasAttribute">
                                            <input formControlName="keyword" type="text" autocomplete="off"
                                                placeholder="Search for listing ..." class="field_field__3U_Rt">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="searchbox_searchInput__2p4ds searchbox_searchInput_address">
                        <div class="field_module__1H6kT field_style5__3OR3T mb-0 js-field">
                            <div class="field_wrap__Gv92k wil-autocomplete-field-wrapper">
                                <div class="field_module__1H6kT field_style2__2Znhe active" posttype="listing">
                                    <div id="autosuggest">
                                        <div role="combobox" aria-expanded="false" aria-haspopup="listbox"
                                            aria-owns="autosuggest-autosuggest__results" class="hasAttribute">
                                            <input formControlName="address" type="text" autocomplete="off"
                                                placeholder="Address ..." class="field_field__3U_Rt"
                                                (keydown)="locationModified = true" (blur)="onLocationBlur()">

                                            <input formControlName="lat" type="hidden" />
                                            <input formControlName="lng" type="hidden" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="searchbox_searchButton__1c9iK">
                        <button class="wil-btn wil-btn--primary wil-btn--round wil-btn--md" type="submit"
                            [disabled]="!listingSearchForm.valid">
                            <i class="la la-search"></i> Search
                        </button>
                    </div>
                </div>
            </form>
        </div>
    </div>

    <section class="wil-section bg-color-gray-2 pt-0">
        <div class="listing-bar_module__2BCsi js-listing-bar-sticky">
            <div class="container">
                <div class="listing-bar_resuilt__R8pwY">
                    We found <span class="color-primary">{{ totalListings }} Listing{{ totalListings | pluralPipe
                        }}</span> <a (click)="resetQueryParams()"
                        class="wil-btn wil-btn--border wil-btn--round wil-btn--xs"><i
                            class="color-primary la la-share"></i>
                        Reset </a></div>
                <ul class="wil-tab-filters list-utility_module__32oNg list-none list-utility_style2__3Gfxe">
                    <li class="list-utility_list__1DzGk"><a href="#" target="_self"
                            class="wil-btn wil-btn--round wil-btn--sm wil-btn--primary wil-switch-post-type-listing disable"
                            style="background-color: rgb(240, 98, 146);"> <i class="la la-list"></i> <span
                                class="">Listing</span>

                        </a></li>
                    <li class="list-utility_list__1DzGk"><a href="#" target="_self"
                            class="wil-btn wil-btn--round wil-btn--sm wil-btn--primary wil-switch-post-type-event"
                            style="background-color: rgb(89, 224, 255);"> <i class="la la-calendar-o"></i> <span
                                class="">Event</span>
                        </a></li>
                </ul>
            </div>
        </div>
        <div class="filter_module__p0Iwz filter-bar gray js-listing-bar-sticky" style="min-height: 59px;">
            <div class="container">
                <div class="">
                    <div class="filter_item__tjou1 mt-10" name="search-form-field-nearbyme">
                        <a (click)="onClickNearMe()" class="filter_button__lo852"
                            [ngClass]="{'wil-btn--primary': queryParams.nearme}">
                            <span class="">Near Me</span>
                        </a>
                    </div>
                    <div class="filter_item__tjou1 mt-10">
                        <a (click)="openListingCategoryModal()" class="filter_button__lo852"
                            [ngClass]="{'wil-btn--primary': queryParams.category}">
                            <span class="">{{selectedCategory != null ? 'Category: '+selectedCategory :
                                'Category'}}</span>
                        </a>
                    </div>
                    <div class="filter_item__tjou1 mt-10" name="search-form-field-best_viewed">
                        <a (click)="queryParams.orderby = 'view'; onSubmitListingForm()" class="filter_button__lo852 "
                            [ngClass]="{'wil-btn--primary': queryParams.orderby == 'view'}">
                            <span class="">Most Viewed</span>
                        </a>
                    </div>
                    <div class="filter_item__tjou1 mt-10" name="search-form-field-newest">
                        <a (click)="queryParams.orderby = 'created_at'; onSubmitListingForm()"
                            class="filter_button__lo852 "
                            [ngClass]="{'wil-btn--primary': queryParams.orderby == 'created_at'}">
                            <span class="">Newest</span>
                        </a>
                    </div>
                    <div class="filter_item__tjou1 mt-10" name="search-form-field-recommended">
                        <a class="filter_button__lo852 "
                            (click)="queryParams.recommended = queryParams.recommended == 0 ? 1 : 0; onSubmitListingForm()"
                            [ngClass]="{'wil-btn--primary': queryParams.recommended}">
                            <span class="">Recommended</span>
                        </a>
                    </div>
                    <div class="filter_item__tjou1 mt-10" name="search-form-field-best_rated">
                        <a (click)="queryParams.orderby = 'avg_rating'; onSubmitListingForm()"
                            [ngClass]="{'wil-btn--primary': queryParams.orderby == 'avg_rating'}"
                            class="filter_button__lo852 ">
                            <span class="">Rating</span>
                        </a>
                    </div>
                    <div class="filter_item__tjou1 mt-10">
                        <a (click)="openListingPriceModal()" class="filter_button__lo852"
                            [ngClass]="{'wil-btn--primary': queryParams.price}">
                            <span class="">{{selectedPrice != null ? 'Price: '+selectedPrice :
                                'Price'}}</span>
                        </a>
                    </div>
                    <!-- <div class="filter_item__tjou1 mt-10">
                        <a (click)="openListingSortModal()" class="filter_button__lo852"
                            [ngClass]="{'wil-btn--primary': queryParams.order}">
                            <span class="">{{selectedSort != null ? 'Sort By: '+selectedSort :
                                'Sort By'}}</span>
                        </a>
                    </div> -->
                    <!-- <div class="filter_item__tjou1 mt-10" name="search-form-field-open_now" ><a
                            href="#" target="_self" class="filter_button__lo852 ">
                            <span class="">Open Now</span>
                        </a></div> -->




                    <div class="filter_item__tjou1 mt-10" name="search-form-field-discount">
                        <a (click)="queryParams.discount = queryParams.discount == 0 ? 1 : 0; onSubmitListingForm()"
                            class="filter_button__lo852 " [ngClass]="{'wil-btn--primary': queryParams.discount}">
                            <span class="">Discount</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <div id="wil-results-wrapper" class="container mt-30">
            <div class="row flex-sm">
                <div class="w-100 flex-lg wil-page-content" style="order: 0;">
                    <div class="w-100">
                        <div *ngIf="totalListings == 0" class="alert_module__Q4QZx" style="padding-left: 15px;">
                            <div class="alert_content__1ntU3">Sorry, We found no posts matched what are you looking for
                                ...</div>
                        </div>
                        <div *ngIf="totalListings > 0" class="wil-grid-wrapper">
                            <div data-col-xs-gap="10" data-col-sm-gap="10" data-col-md-gap="15"
                                class="wil-flex-wrap row js-listing-grid">
                                <div *ngFor="let item of listings" class="col-lg-3 col-md-3 col-sm-6 col-xs-6">
                                    <article
                                        class="listing_module__2EnGq wil-shadow js-listing-module wil-flex-column-between wil-shadow wil-flex-column-between">
                                        <div class="listing_firstWrap__36UOZ">
                                            <header class="listing_header__2pt4D is-verified">
                                                <a href="{{ siteUrl + '/listing/' + item.slug }}"><span
                                                        class="wilcity-slider-gradient-before"></span>
                                                    <div *ngIf="item.cover_img"
                                                        class="listing_img__3pwlB pos-a-full bg-cover"
                                                        [ngStyle]="{'background-image': 'url(' + getListingImageSrc(item.cover_img, 'medium') + ')'}">
                                                        <img *ngIf="item.cover_img"
                                                            src="{{ item.cover_img | imageSrc : 'listing' : 'medium' }}"
                                                            alt="{{ item.title }}">
                                                    </div> <span class="wilcity-slider-gradient-after"></span>
                                                </a>
                                            </header>
                                            <div class="listing_body__31ndf">
                                                <a href="{{ siteUrl + '/listing/' + item.slug }}"
                                                    class="listing_goo__3r7Tj">
                                                    <div *ngIf="item.logo" class="listing_logo__PIZwf bg-cover"
                                                        [ngStyle]="{'background-image': 'url(' + getListingImageSrc(item.logo, 'thumb') + ')'}">
                                                    </div>
                                                </a>
                                                <h2 class="listing_title__2920A title-ellipsis-2">
                                                    <a href="{{ siteUrl + '/listing/' + item.slug }}">{{ item.title
                                                        }}</a>
                                                </h2>
                                                <!-- <div class="listing_tagline__1cOB3">
                                                    {{ item.description | excerpt : 15 }}</div> -->
                                                <div class="listing_meta__card">
                                                    <a href="{{ siteUrl + '/listing/' + item.slug }}" target="_blank"
                                                        title="{{ item.address }}"> <i class="la la-map-marker"></i>
                                                        <span class=""></span>
                                                    </a>
                                                    <a *ngIf="item.contact && item.contact.website != ''"
                                                        href="{{ item.contact.website }}"> <i class="la la-globe"></i>
                                                    </a>
                                                    <a *ngIf="item.contact && item.contact.email != ''"
                                                        href="mailto:{{ item.contact.email }}"> <i
                                                            class="la la-envelope"></i>
                                                    </a>
                                                    <a *ngIf="item.contact && item.contact.phone != ''"
                                                        href="tel:{{ item.contact.phone }}"> <i class="la la-phone"></i>
                                                    </a>
                                                </div>
                                            </div>
                                        </div>
                                        <footer class="listing_footer__1PzMC">
                                            <div *ngIf="item.categories.length > 0" class="text-ellipsis">
                                                <div
                                                    class="icon-box-1_module__uyg5F text-ellipsis icon-box-1_style2__1EMOP">
                                                    <div class="icon-box-1_block1__bJ25J"><a
                                                            href="{{ siteUrl }}/listing/search/?listing_cat={{ item.categories[0].listing_categories_id }}"
                                                            class="text-ellipsis">
                                                            <div class="icon-box-1_icon__3V5c0 rounded-circle"><img
                                                                    src="{{ item.categories[0].image | imageSrc : 'listing' : 'thumb' }}"
                                                                    alt="{{ item.categories[0].title }}"></div> <span
                                                                class="icon-box-1_text__3R39g">{{
                                                                item.categories[0].title }}</span>
                                                        </a></div>
                                                </div>
                                            </div>
                                            <div class="listing_footerRight__2398w">
                                                <a (click)="onClickListingFavorite(item.id)"
                                                    class="wil-favorite-btn wil-favorite-20570">
                                                    <i [ngClass]="item.is_favorite ? 'la-heart color-primary' : 'la-heart-o'"
                                                        class="la"></i>
                                                </a>
                                            </div>
                                        </footer>
                                    </article>
                                </div>
                            </div>
                        </div>
                        <nav *ngIf="pagination.pages && pagination.pages.length > 1" class="mt-20 mb-20"
                            name="after-grid">
                            <ul class="pagination_module__1NBfW">
                                <li *ngIf="pagination.currentPage != 1" class="pagination_pageItem__3SatM">
                                    <a (click)="onClickPagination(1)" class="pagination_pageLink__2UQhK"><i
                                            class="la la-angle-double-left"></i></a>
                                </li>
                                <li *ngIf="pagination.totalPages > 1"
                                    [ngClass]="{'disable':pagination.currentPage === 1}"
                                    class="pagination_pageItem__3SatM">
                                    <a (click)="onClickPagination(pagination.currentPage - 1)"
                                        class="pagination_pageLink__2UQhK"><i class="la la-angle-left"></i></a>
                                </li>
                                <li *ngFor="let page of pagination.pages"
                                    [ngClass]="{'current':pagination.currentPage === page}"
                                    class="pagination_pageItem__3SatM">
                                    <a (click)="onClickPagination(page)"
                                        class="pagination_pageLink__2UQhK"><span>{{page}}</span></a>
                                </li>
                                <li *ngIf="pagination.totalPages > 1"
                                    [ngClass]="{'disable':pagination.currentPage === pagination.totalPages}"
                                    class="pagination_pageItem__3SatM">
                                    <a (click)="onClickPagination(pagination.currentPage + 1)"
                                        class="pagination_pageLink__2UQhK"><i class="la la-angle-right"></i></a>
                                </li>
                                <li *ngIf="pagination.currentPage != pagination.totalPages"
                                    class="pagination_pageItem__3SatM">
                                    <a (click)="onClickPagination(pagination.totalPages)"
                                        class="pagination_pageLink__2UQhK"><i class="la la-angle-double-right"></i></a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <!---->
                </div>
            </div>
        </div>
    </section>
</div>